/* eslint-disable react/style-prop-object */
import React from "react";

export interface IconExampleProps {
    className?: string;
  }
const IconVideo: React.FC<IconExampleProps> = ({ className = "" }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="#0866ff"
      className={`${className}`}
    >
      <path d="M14.573 2H9.427c-1.824 0-3.293 0-4.45.155-1.2.162-2.21.507-3.013 1.31C1.162 4.266.817 5.277.655 6.477.5 7.634.5 9.103.5 10.927v.146c0 1.824 0 3.293.155 4.45.162 1.2.507 2.21 1.31 3.012.802.803 1.813 1.148 3.013 1.31C6.134 20 7.603 20 9.427 20h5.146c1.824 0 3.293 0 4.45-.155 1.2-.162 2.21-.507 3.012-1.31.803-.802 1.148-1.813 1.31-3.013.155-1.156.155-2.625.155-4.449v-.146c0-1.824 0-3.293-.155-4.45-.162-1.2-.507-2.21-1.31-3.013-.802-.802-1.813-1.147-3.013-1.309C17.866 2 16.397 2 14.573 2zm-3.577 6.132 3.5 2a1 1 0 0 1 0 1.736l-3.5 2A1 1 0 0 1 9.5 13V9a1 1 0 0 1 1.496-.868zM7 22.5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1z"></path>
    </svg>
  );
};

export default IconVideo;
